import { cookie } from '@pdrj/pmi-iqos-shared-react'
import { getPaginationParams } from '@iqosphere-common/utils'

export default class IqosphereProfile {
  constructor(api) {
    this.api = api
  }

  getMembershipCardQrImage = async () => {
    const res = await this.api.get('/iqosphere/qr', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getMembershipCardQrImage')
    })
    return res
  }

  getQoinsActions = async () => {
    const res = await this.api.get('/iqosphere/qoins/earning', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQoinsActions')
    })
    return res
  }

  getQoinsExpiring = async () => {
    const res = await this.api.get('/iqosphere/qoins/expiring', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQoinsExpiring')
    })
    return res
  }

  getQoinsHistory = async (
    historyPaginationIndex = 0,
    historyPageSize = 10,
    type = 'all'
  ) => {
    const res = await this.api.get(
      '/iqosphere/qoins/history?type=' +
        type +
        getPaginationParams(historyPaginationIndex, historyPageSize),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getQoinsHistory')
      }
    )
    return res
  }

  getProfile = async () => {
    const res = await this.api.get('/profile', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getProfile')
    })

    return res
  }

  setProfile = async () => {
    const res = await this.api.post('/profile', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {},
      mock: this.api.getMock('setProfile')
    })

    return res
  }

  getNotices = async (pageIndex, pageSize) => {
    const res = await this.api.get(
      '/iqosphere/notices' + getPaginationParams(pageIndex, pageSize, true),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getNotices')
      }
    )

    return res
  }

  updateNotice = async id => {
    const res = await this.api.post('/iqosphere/notices?rpc=true', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        noticeId: id
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('getNotices')
    })
    return res
  }

  getPrizes = async () => {
    const res = await this.api.get('/iqosphere/prizes/profile', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getProfilePrizes')
    })

    return res
  }

  getPrizesBarcode = async () => {
    const res = await this.api.get('/iqosphere/prizes/qrcode', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getPrizesBarcode')
    })
    return res
  }

  updateAvatarProfile = async ({ avatar, accessory }) => {
    const res = await this.api.post('/iqosphere/profile/avatar', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        avatar,
        accessory
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('updateAvatarProfile')
    })

    return res
  }

  getAvatarProfile = async () => {
    const res = await this.api.get('/iqosphere/profile/avatar', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('avatarProfile')
    })

    return res
  }

  getAvatarAccessories = async () => {
    const res = await this.api.get('/iqosphere/profile/accessories', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('avatarAccessories')
    })

    return res
  }
}
